import React from 'react'
import { WemoloButton, WemoloMenu, WemoloMenuOption, WemoloPlusIcon } from '../../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT } from '../../config'
import styles from './AddFilter.module.css'

export type AddFilterUIProps = {
    isMenuOpen: boolean
    availableFilters: WemoloMenuOption[]
    menuRef: React.RefObject<HTMLDivElement>
    onAddFilterClick: () => void
    onFilterSelect: (value: string) => void
}

export const AddFilterUI: React.FC<AddFilterUIProps> = ({
    isMenuOpen,
    availableFilters,
    menuRef,
    onAddFilterClick,
    onFilterSelect
}) => (
    <div ref={menuRef} className={styles.root}>
        <WemoloButton view="secondary" size="small" icon={<WemoloPlusIcon />} onClick={onAddFilterClick}>
            {DETECTION_EXPLORER_TEXT.filters.addFilter}
        </WemoloButton>

        {isMenuOpen && (
            <div className={styles.popover}>
                <WemoloMenu options={availableFilters} value={[]} onClick={onFilterSelect} />
            </div>
        )}
    </div>
)
